import { useEffect, useState } from 'react';
import api from '@/lib/api';

interface Carrier {
  id: string;
  name: string;
  code: string;
  serviceType: string;
  active: boolean;
}

const serviceTypeLabels: Record<string, string> = {
  EXPRESS: 'Expresso',
  STANDARD: 'Padrao',
  ECONOMY: 'Economico',
  SAME_DAY: 'Mesmo Dia',
};

export default function CarriersPage() {
  const [carriers, setCarriers] = useState<Carrier[]>([]);
  const [loadingData, setLoadingData] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', code: '', serviceType: 'STANDARD' });

  useEffect(() => {
    api.get('/carriers').then((r) => {
      setCarriers(r.data);
      setLoadingData(false);
    });
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post('/carriers', formData);
    setShowModal(false);
    setFormData({ name: '', code: '', serviceType: 'STANDARD' });
    api.get('/carriers').then((r) => setCarriers(r.data));
  };

  return (
    <>
    <div className="flex items-center justify-end mb-6">
        <button
          onClick={() => setShowModal(true)}
          className="px-4 py-2 bg-primary-600 text-white rounded-lg text-sm font-medium hover:bg-primary-700 transition-colors"
        >
          Nova Transportadora
        </button>
      </div>

      {loadingData ? (
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carriers.map((carrier) => (
            <div key={carrier.id} className="bg-white rounded-xl p-6 shadow-sm border border-dark-100 hover:shadow-md transition-shadow">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-lg font-semibold text-dark-900">{carrier.name}</h3>
                  <p className="text-sm text-primary-600 font-medium">{carrier.code}</p>
                </div>
                <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${carrier.active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                  {carrier.active ? 'Ativa' : 'Inativa'}
                </span>
              </div>
              <div className="pt-4 border-t border-dark-100">
                <span className="px-3 py-1 bg-dark-100 text-dark-700 rounded-full text-xs font-medium">
                  {serviceTypeLabels[carrier.serviceType] || carrier.serviceType}
                </span>
              </div>
            </div>
          ))}
          {carriers.length === 0 && (
            <div className="col-span-full text-center py-12 text-dark-500">Nenhuma transportadora encontrada</div>
          )}
        </div>
      )}

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-bold text-dark-900 mb-4">Nova Transportadora</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-dark-700 mb-1">Nome</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-dark-700 mb-1">Codigo</label>
                <input
                  type="text"
                  value={formData.code}
                  onChange={(e) => setFormData({ ...formData, code: e.target.value })}
                  className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-dark-700 mb-1">Tipo de Servico</label>
                <select
                  value={formData.serviceType}
                  onChange={(e) => setFormData({ ...formData, serviceType: e.target.value })}
                  className="w-full px-3 py-2 border border-dark-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                >
                  <option value="EXPRESS">Expresso</option>
                  <option value="STANDARD">Padrao</option>
                  <option value="ECONOMY">Economico</option>
                  <option value="SAME_DAY">Mesmo Dia</option>
                </select>
              </div>
              <div className="flex gap-4 pt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="flex-1 px-4 py-2 border border-dark-200 rounded-lg text-sm font-medium hover:bg-dark-50 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-2 bg-primary-600 text-white rounded-lg text-sm font-medium hover:bg-primary-700 transition-colors"
                >
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
